import { createSelector } from "reselect"

export const selectCounties = state => state.counties

export const selectCountiesAsArray = createSelector(
    selectCounties, counties => Object.values(counties)
)

export const selectCountyId = (state, ownProps) => ownProps.countyId

export const selectCounty = createSelector(
    selectCountiesAsArray, selectCountyId,
    (counties, id) => {
        return counties.find(county => county.id.toString() === id)
    }
)


// WEBPACK FOOTER //
// src/data/counties/selectors.js